export enum gameEnum {
    MATCH = 'matching/startMatching', // pvp 匹配
    CANCEL_MATCH = 'matching/cancelMatching', // pvp 取消匹配
    BOARD_INFO = 'game/getGameInfo', // 获取当前棋盘信息
    MOVE = 'game/playChess', // 下棋
    SUBMIT_REQUEST = 'game/chessApply', // 寻求认输/悔棋/和棋
    HANDLE_REQUEST = 'game/chessHandle', // 处理认输/悔棋/和棋
    UPDATE_GAME_CONFIG = 'game/updateGameConfig', // 修改对局配置
    SAVE_PVE_CHESSBOOK = 'game/pve/save', // 保存人机对弈棋谱
    /**
     * 获取游戏配置
     */
    GAME_CONFIG = 'game/gameConfigGet',
    /**
     * 编辑游戏配置
     */
    EDIT_GAME_CONFIG = 'game/gameConfigEdit',

    /**
     * 上传 pgn 到对局
     */
    EDIT_PGN_REPORT = 'game/updateGamePgnReport',
}

/**
 * 固定练习接口
 */
export enum stableExerciseEnum {
    CATE = 'subject/fixed/getSubjectCateList', // 类目
    LIST = 'subject/fixed/getSubjectList', // 列表
    INFO = 'subject/fixed/getSubjectInfo', // 详情
    LAST = 'subject/fixed/getLastSubject', // 默认
    NEXT = 'subject/fixed/nextSubject', // 下一题
    FINISH = 'subject/fixed/completeSubject', // 完成习题
}

/**
 * 开局练习接口
 */
export enum openingExerciseEnum {
    CATE = 'subject/opening/getSubjectCateList', // 类目
    LIST = 'subject/opening/getSubjectList', // 列表
    INFO = 'subject/opening/getSubjectInfo', // 详情
    LAST = 'subject/opening/getLastSubject', // 默认
    NEXT = 'subject/opening/nextSubject', // 下一题
    FINISH = 'subject/opening/completeSubject', // 完成习题
}

export enum recordEnum {
    GET_GAME_REPORT = 'game/analyse/getStockFishById', // 获取报告
    GET_FEN_EVALUATE = 'game/analyse/getStockFishByFen', // 获取 fen 报告
}

/**
 * 随机习题接口
 */
export enum randomExerciseEnum {
    START = 'subject/rand/startSubject', // 开始
    GET = 'subject/rand/getRandSubject', // 获取
    FINISH = 'subject/rand/completeSubject', // 完成习题
}

/**
 * 冲刺接口
 */
export enum sprintExerciseEnum {
    START = 'subject/sprint/startSprint', // 开始
    GET = 'subject/sprint/getSubjectList', // 获取
    MOVE = 'subject/sprint/move', // 移动
}

/**
 * 冲刺 PK 接口
 */
export enum sprintPKEnum {
    INIT = 'subject/friend/initRoom', // 初始化房间
    INVITE = 'subject/friend/invite', // 邀请好友
    INVITE_ALL = 'subject/friend/inviteAll', // 批量邀请
    JOIN = 'subject/friend/joinRoom', // 同意邀请
    REFUSE = 'subject/friend/refuseInvite', // 拒绝邀请
    EXIT = 'subject/friend/exitRoom', // 退出房间
    START = 'subject/friend/startGame', // 开始游戏
    USER = 'subject/friend/getUserList', // 获取房间内用户列表
    GET = 'subject/friend/getSubjectList', // 获取习题列表
    MOVE = 'subject/friend/move', // 移动
}

export enum openTreeExerciseEnum {
    /**
     * 获取推荐走法列表
     */
    RECOMMEND = 'subject/openingTree/play',

    /**
     * 搜索
     */
    SEARCH = 'subject/openingTree/getList',

    /**
     * 获取开局详情
     */
    DETAIL = 'subject/openingTree/getInfo',
}

export enum openAiTrainExerciseEnum {
    /**
     * 获取开局列表
     */
    LIST = 'subject/dynamicOpening/getList',
    /**
     * 开始
     */
    START = 'subject/dynamicOpening/start',
    /**
     * 下棋
     */
    MOVE = 'subject/dynamicOpening/play',
    /**
     * 获得结果
     */
    RESULT = 'subject/dynamicOpening/end',
    /**
     * 回退
     */
    BACK = 'subject/dynamicOpening/back',
    /**
     * 历史记录-图表
     */
    HISTORY_CHART = 'subject/dynamicOpening/getHistoryChart',
    /**
     * 历史记录-列表
     */
    HISTORY_LIST = 'subject/dynamicOpening/getHistoryList',
}

/**
 * 举报
 */
export enum reportEnum {
    commit = 'report/putReport', // 提交举报
}

/**
 * 收藏
 */
export enum collectEnum {
    COMMIT = 'user/userCollectionPut', // 提交收藏
    LIST = 'user/userCollectionList', // 查询列表
    CANCEL = 'user/userCollectionDel', // 取消收藏
    CHECK = 'user/isUserCollection', // 是否收藏
}

/**
 * 注册页
 */
export enum register {
    /**
     * 获取验证码
     */
    GET_CODE = 'login/putCode',
    /**
     * 获取邮箱验证码
     */
    GET_MAIL_CODE = 'login/putEmailCode',
    /**
     * 手机号登录
     */
    LOGIN_PHONE = 'login/loginWithMobile',
    /**
     * 微信扫码登录
     */
    LOGIN_WX = 'login/pcWechatLogin',
    /**
     * 邮箱登录
     */
    LOGIN_EMAIl = 'login/emailLogin',
    /**
     * 微信授权登录
     */
    LOGIN_WECHAT = 'login/loginWithWechat',
    /**
     * 微信授权登录
     */
    LOGIN_MP_WECHAT = 'login/miniAppLogin',
    /**
     * 微信授权登录
     */
    LOGIN_APPLE = 'login/appleLogin',
    /**
     * 绑定手机号
     */
    BIND_PHONE = 'login/bindPhone',
}

/**
 * 首页
 */
export enum index {
    /**
     * banner
     */
    BANNER_LIST = 'banner/bannerList',
    /**
     * 获取游戏记录
     */
    GAME_RECORD = 'game/userGameLog',
    /**
     * 获取游戏详情
     */
    GAME_DETAIL = 'game/userGameInfo',
    /**
     * 获取直播列表
     */
    LIVE_LIST = 'index/liveList',
    /**
     * 获取直播详情
     */
    LIVE_INFO = 'index/liveInfo',
    /**
     * 获取游戏记录（分页）
     */
    GAME_RECORD_V2 = 'v2/game/userGameLog',
}

/**
 * 用户
 */
export enum user {
    /**
     * 获取游戏信息
     */
    GET_GAME_INFO = 'game/gameInfoGet',
    /**
     * 获取用户随机答题信息
     */
    GET_USER_SUBJECT_INFO = 'user/subject/getUserSubjectInfo',
    /**
     * 编辑个人信息
     */
    EDIT_USER_INFO = 'user/userInfoEdit',
    /**
     * 编辑用户头像
     */
    EDIT_USER_AVATAR = 'user/editAvatar',
    /**
     * 获取头像列表
     */
    GET_AVATAR_LIST = 'config/getAvatar',
    /**
     * 获取用户积分信息
     */
    POINT = 'point/userPoint',
    /**
     * 获取用户游戏信息
     */
    GAME_INFO = 'game/userGameWin',
    /**
     * 获取用户游戏状态
     */
    GAME_STATUS = 'game/gameStatusGet',
    /**
     * 用户基本信息查询
     */
    BASE_INFO = 'user/userInfoGet',
    /**
     * 判断俩人是否是好友
     */
    IS_FRIEND = 'friend/isFriend',
    /**
     * 勋章列表
     */
    MEDAL_LIST = 'user/badge/getUserBadgeList',
    /**
     * 勋章详情
     */
    MEDAL_INFO = 'user/badge/getBadgeInfo',
    /**
     * 注销
     */
    LOGOUT = 'user/delUser',
    /**
     * 获取等级认证列表
     */
    LEVEL_LIST = 'config/chessGrade',
    /**
     * 查询用户权益列表
     */
    PRIVILEGE_LIST = 'user/privilege/getList',
    /**
     * 计算CY值
     */
    COUNT_CY_INFO = 'game/analyse/countCyInfo',
}

/**
 * 资讯 | 新闻
 */
export enum news {
    /**
     * 获取 资讯 | 新闻 详情
     */
    GET_NEWS_INFO = 'index/newsInfo',
    /**
     * 获取新闻列表
     */
    GET_NEWS_LIST = 'index/newsList',
}

/**
 * 实名认证
 */
export enum realNameAuth {
    /**
     * 实名认证
     */
    USER_AUTH = 'user/userAuthentication',
    /**
     * 查询实名认证信息
     */
    STATUS = 'user/getAuthentication',
}

/**
 * 系统公告
 */
export enum notice {
    /**
     * 公告列表
     */
    NOTICE_LIST = 'notice/getList',
    /**
     * 删除公告
     */
    CLEAR_NOTICE = 'notice/delNotice',
    /**
     * 获取公告详情
     */
    NOTICE_INFO = 'notice/getInfo',
    /**
     * 全部已读
     */
    READ_ALL = 'notice/readNotice',
}

/**
 * 好友申请
 */
export enum friend {
    /**
     * 好友列表
     */
    LIST = 'friend/friendList',
    /**
     * 好友申请列表
     */
    // APPLY_LIST = "friend/appFriendList",
    APPLY_LIST = 'friend/friendApplyList',
    /**
     * 清除申请记录
     */
    CLEAR_LIST = 'friend/delFriendApp',
    /**
     * 删除好友
     */
    DELETE = 'friend/delFriend',
    /**
     * 同意/拒绝好友申请
     */
    READ_ALL = 'friend/appFriend',
    /**
     * 搜索好友
     */
    SEARCH = 'friend/friendInfo',
    /**
     * 修改备注
     */
    EDIT_REMARK = 'friend/editFriend',
    /**
     * 获取好友积分
     */
    SCORE = 'friend/friendsPoint',
    /**
     * 获取好友胜率
     */
    WIN = 'friend/friendGameWin',
    /**
     * 添加好友
     */
    ADD = 'friend/addFriend',
    /**
     * 邀请对局
     */
    INVITE = 'game/friend/invite',
    /**
     * 取消邀请对局
     */
    CANCEL = 'game/friend/cancel',
    /**
     * 接受对局邀请
     */
    ACCEPT = 'game/friend/accept',
    /**
     * 拒绝对局邀请
     */
    REFUSE = 'game/friend/refuse',
}

export enum common {
    /**
     * 上传文件到oss
     */
    UPLOAD_FILE = 'other/oss_upload',
    /**
     * 图片审核
     */
    IMAGE_REVIEW = 'other/fileReview',
    /**
     * 文字审核
     */
    TEXT_REVIEW = 'other/textReview',
}

export enum product {
    /**
     * 获取商品类目列表
     */
    GET_CATE_LIST = 'goods/cate/getList',
    /**
     * 后去商品列表
     */
    GET_LIST = 'goods/info/getList',
}

export enum payment {
    /**
     * 创建订单
     */
    CREATE_ORDER = 'order/create',

    /**
     * 获取支付二维码
     */
    GET_QR_CODE = 'pay/wechatNativePay',

    /**
     * 获取订单详情
     */
    GET_ORDER_INFO = 'order/getInfo',

    /**
     * 关闭订单
     */
    CLOSE_ORDER = 'order/closeOrder',
}

export enum championships{
    MATCH = 'game/match/startMatching', //  匹配
    CANCEL_MATCH = 'game/match/cancelMatching', //  取消匹配
    BOARD_INFO = 'game/match/getGameInfo', // 获取当前棋盘信息
    MOVE = 'game/match/playChess', // 下棋
    SUBMIT_REQUEST = 'game/match/chessApply', // 寻求认输/悔棋/和棋
    HANDLE_REQUEST = 'game/match/chessHandle', // 处理认输/悔棋/和棋
}